const listeners = new Set<() => void>();

export function onSessionExpired(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

// Só 401 encerra a sessão. 403/404 continuam sendo erros da operação.
export function reportSessionStatus(status: number): void {
  if (status === 401) for (const listener of listeners) listener();
}
